import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiProfileIconStackedComponent } from './fi-profile-icon-stacked.component';
import { FiProfileIconModule } from '../profile-icon/profile-icon.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';

@NgModule({
    imports: [CommonModule, FiProfileIconModule, InfoIconModule],
    declarations: [FiProfileIconStackedComponent],
    exports: [FiProfileIconStackedComponent],
})
export class FiProfileIconStackedModule {}
